import React, { useContext, useEffect, useState } from 'react';
import { getAuthorizedPersonsProfile } from '../../../actions';
import { Context } from '../../../defaults';
import { Table } from 'antd';

const SchoolSubjects = () => {
    const { dictionary, language } = useContext(Context);
    const [teachersSubjectsItems, setTeachersSubjectsItems] = useState([]);

    const initTable = []
    useEffect(() => {
        getAuthorizedPersonsProfile().then(({ data }) => data).then((data) => {
            initTable.length = 0;
            data.institution.teachersSubjects.map((el, index) => {
                initTable.push({
                    key: index,
                    subject: data.institution.teachersSubjects[index].subject.nameRus,
                    fullName: (data.institution.teachersSubjects[index].teacher.lastName + ' '
                        + data.institution.teachersSubjects[index].teacher.firstName + ' '
                        + data.institution.teachersSubjects[index].teacher.middleName),
                })
            })
            setTeachersSubjectsItems(initTable)
        });
    }, []);


    const columns = [
        {
            title: dictionary?.SubjectsName[language],
            dataIndex: 'subject',
            key: 'subject',
        },
        {
            title: dictionary?.TeachersFIO[language],
            dataIndex: 'fullName',
            key: 'fullName',
        },
    ];


    return (

        <React.Fragment>
            <Table columns={columns} dataSource={teachersSubjectsItems} />
        </React.Fragment>
    );
};
export default SchoolSubjects